var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verifyProtocol"},[_c('h3',{staticClass:"title"},[_vm._v("隐私政策")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.protocol)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }